import React, { useEffect, useState } from 'react';
import styles from './ReviewItem.module.scss';
import RichContent from 'components/common/RichContent';
import RoundIcon from 'components/common/RoundIcon';
import Link from 'next/link';
import BadgeIcon from 'components/common/BadgeIcon';
import { CourseReviewItem } from 'service/course';
import useStore from 'store/timeline';
import useGlobalStore from 'store/global';
import axios from 'axios';
import Icon from 'components/common/Icon';
import { Rating } from '@material-ui/lab';

export type Props = {
  reviewItem: CourseReviewItem;
};

function ReviewItem({ reviewItem }: Props): JSX.Element {
  const [isFollowed, setIsFollowed] = useState(reviewItem.user?.is_followed);
  const currentUser = useStore((state) => state.currentUser);
  const showLogin = useGlobalStore((state) => state.showLogin);
  useEffect(() => {
    setIsFollowed(reviewItem.user?.is_followed);
  }, [reviewItem.user?.is_followed]);
  const handleFollowClick = async (userId: number, isFollowed: boolean) => {
    if (currentUser) {
      const action = isFollowed ? 'unfollow' : 'follow';
      if (isFollowed) {
        setIsFollowed(false);
      } else {
        setIsFollowed(true);
      }
      await axios.post(`/users/follows`, {
        user_id: userId,
        action: action,
      });
    } else {
      showLogin({});
    }
  };

  return (
    <div className={styles.postCommentWrapper}>
      <div className={styles.userInfo}>
        <div className={styles.avatar}>
          <RoundIcon
            user={reviewItem.user}
            width={35}
            height={35}
            enableClick
            hasRing
          />
        </div>
        <div className={styles.nameJob}>
          <Link href={`/${reviewItem.user?.username}`}>
            <a>
              <div className={styles.userNameText}>{reviewItem.user?.name}</div>
            </a>
          </Link>
          <Rating value={reviewItem.rating} readOnly name="currentUserRating" />
        </div>
        <div className={styles.badge}>
          <BadgeIcon badge={reviewItem.user?.badge} width={34} height={34} />
        </div>
        {!isFollowed && currentUser?.id !== reviewItem.user?.id && (
          <Icon
            name="follow"
            width={32}
            height={32}
            isOn={isFollowed}
            hasOn
            hasHover
            onClick={() => handleFollowClick(reviewItem.user?.id, isFollowed)}
          />
        )}
      </div>
      {reviewItem.comment?.trim() && (
        <div className={styles.contentBox}>
          <div className={styles.content}>
            <RichContent text={reviewItem.comment} />
          </div>
        </div>
      )}
    </div>
  );
}

const MemoizedReviewItem = React.memo(ReviewItem);
export default MemoizedReviewItem;
